module.exports = __webpack_public_path__ + "media/images/lb/046-2a10377bf45b5937ed79e405336420eb.svg";